<div class="pt-page">
  <div class="pt-stack">
    <div *ngIf="loading$ | async" class="pt-loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p>Loading policy information...</p>
    </div>

    <div *ngIf="error$ | async as error" class="pt-error">
      <p>{{ error }}</p>
    </div>

    <ng-container *ngIf="policy$ | async as policy">
      <app-policy-tracker-header [policy]="policy" [state]="state(policy)"></app-policy-tracker-header>

      <!-- Rejection alert -->
      <div class="pt-alert pt-alert--rejected" *ngIf="state(policy) === 'rejected'">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="#eb3055" stroke="none" aria-hidden="true">
          <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm-1.489 7.14a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z"></path>
        </svg>
        <div class="pt-alert__body">
          <div>
            <p class="pt-alert__title">Your policy was rejected</p>
            <p class="pt-alert__reason" *ngIf="rejectionReasons(policy).length === 1">
              Reason: {{ rejectionReasons(policy)[0] }}
            </p>
            <ul class="pt-alert__reasons" *ngIf="rejectionReasons(policy).length > 1">
              <li *ngFor="let reason of rejectionReasons(policy)">{{ reason }}</li>
            </ul>
            <p class="pt-alert__reason" *ngIf="rejectionReasons(policy).length === 0">
              Your policy did not meet your property's insurance requirements.
            </p>
          </div>
          <div class="pt-alert__actions">
            <a class="pt-btn" [routerLink]="resubmitUrl">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path><path d="M7 9l5 -5l5 5"></path><path d="M12 4l0 12"></path>
              </svg>
              Resubmit insurance policy
            </a>
            <span class="pt-alert__hint">Fix the issue above, then upload your corrected policy.</span>
          </div>
        </div>
      </div>

      <!-- Expired alert -->
      <div class="pt-alert pt-alert--expired" *ngIf="state(policy) === 'expired'">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="#f9af39" stroke="none" aria-hidden="true">
          <path d="M12 1.67c.955 0 1.845 .467 2.39 1.247l.105 .16l8.114 13.548a2.914 2.914 0 0 1 -2.307 4.363l-.195 .008h-16.225a2.914 2.914 0 0 1 -2.582 -4.2l.099 -.185l8.11 -13.538a2.914 2.914 0 0 1 2.491 -1.403zm.01 13.33l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -7a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z"></path>
        </svg>
        <div class="pt-alert__body">
          <div>
            <p class="pt-alert__title">Your policy has expired</p>
            <p class="pt-alert__reason">
              Coverage ended on {{ expirationDate(policy) | date : "MMM d, y" }}. Upload a renewed policy to stay covered.
            </p>
          </div>
          <div class="pt-alert__actions">
            <a class="pt-btn" [routerLink]="resubmitUrl">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path><path d="M7 9l5 -5l5 5"></path><path d="M12 4l0 12"></path>
              </svg>
              Upload renewed policy
            </a>
          </div>
        </div>
      </div>

      <app-policy-tracker-timeline [policy]="policy" [state]="state(policy)"></app-policy-tracker-timeline>

      <app-policy-tracker-info [policy]="policy"></app-policy-tracker-info>
    </ng-container>
  </div>
</div>
